export const CardBook = {
  transclude: {
    left: 'leftPage',
    right: 'rightPage',
  },

  template: `
    <section class="d-flex card-book">
      <div class="left-page col-6" ng-transclude="left"></div>
      <div class="right-page col-6" ng-transclude="right"></div>
    </section>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/CardBook.js